import { render, staticRenderFns } from "./SalesDepartmentBlock.vue?vue&type=template&id=c12c8d6c&scoped=true&"
import script from "./SalesDepartmentBlock.vue?vue&type=script&lang=js&"
export * from "./SalesDepartmentBlock.vue?vue&type=script&lang=js&"
import style0 from "./SalesDepartmentBlock.vue?vue&type=style&index=0&id=c12c8d6c&prod&lang=scss&scoped=true&"
import style1 from "./SalesDepartmentBlock.vue?vue&type=style&index=1&id=c12c8d6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12c8d6c",
  null
  
)

export default component.exports